export const SIGN_IN_BASE_URL = '/sign-in';
export const SIGN_OUT_BASE_URL = '/sign-out';
export const ERROR_BASE_URL = '/error';
export const PARSER_BASE_URL = '/parser';
export const AD_BASE_URL = '/ads';
